import React from 'react';
import SarasTrans from '../../notifications/SarasTrans';

//use this dialog where the form cannot be dragged and actions are passed as children
const SarasDialogCustomAction = (props)=>{
    const {formStyle, title, contentStyle, actionStyle, actionChildren, children} = props;

    return(
        <div className="uiDialogContent">
            <div className="phViewArea" style={formStyle ? formStyle : {}}>
                <div className='phPopupContainer' >
                    <div className="phViewHeading" >
                        <div className="phTitle" >
                            <span><SarasTrans value = {title}/></span>
                        </div>
                    </div>
                    <div className="phPopupContent" style={contentStyle ? contentStyle : {}}>
                        {children}
                    </div>
                    <div className="phPopupAction" style={actionStyle ? actionStyle : {}}>
                        {actionChildren}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SarasDialogCustomAction;
